import { COOKIE_MAILING_ANON_NAME } from "../utilities/constants";

function getAdstaxIDValue() {
    return getAnonIDValue() || getCookieUUIDValue();
}

function getCookieUUIDValue() {
    return document.cookie.split("; ").find(row => row.startsWith("__cq_uuid="))?.split("=")[1] || "";
}

function getAnonIDValue() {
    return document.cookie.split("; ").find(row => row.startsWith(COOKIE_MAILING_ANON_NAME+"="))?.split("=")[1] || null;
}

module.exports = {
    getAdstaxIDValue: getAdstaxIDValue,
    getCookieUUIDValue: getCookieUUIDValue,
    getAnonIDValue: getAnonIDValue
};
